module.exports = __webpack_public_path__ + "static/img/bg_mob.deb08dce.jpg";